import type { FC } from 'react';
import classnames from 'classnames';
import { SvgIcon } from 'root/widgets/svg-icon';
import { BadgeVariant } from 'root/widgets/verified-badge/types';
import { HIVE_UI_CORE_URL, MARKETPLACE } from 'root/widgets/constants';
import { Badge } from 'root/widgets/common-components/badge';
import { Typography } from 'root/common/atom-elements/typography';

interface BadgeButtonProps {
  variant: BadgeVariant;
  marketplace: MARKETPLACE;
  icon: string;
  text: string;
  onClick: () => void;
}

const BadgeButton: FC<BadgeButtonProps> = ({ variant, marketplace, icon, text, onClick }) => (
  <Badge
    metadata={{
      dataAutomationId: `${variant}-badge-btn`,
    }}
    type="small"
    variant="primary"
    className={classnames('verified-badge__button', `verified-badge__button--${variant}`, marketplace)}
    onClick={onClick}
  >
    <SvgIcon
      src={`${HIVE_UI_CORE_URL}icons/svgs/${icon}.svg`}
      width={16}
      height={16}
      title={text}
      shouldUseImage
      color="white"
    />
    <Typography variant="caption-xs">{text}</Typography>
  </Badge>
);

export default BadgeButton;
